import barbellImage from '../../../asset/image/grnd-101-barbell.png'
import { ImageUrl } from 'src/component/image/image-url'
import React from 'react'

export const AuthSplitHeroPanel = (): React.ReactElement => {
  return (
    <div className="hidden lg:block lg:w-1/2 lg:min-h-screen relative">
      <ImageUrl url={barbellImage} alt="" className="absolute inset-0 w-full h-full object-cover object-top" />
      <div
        className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent pointer-events-none"
        aria-hidden
      />
      <div className="absolute left-[50px] bottom-[40px] right-[50px]">
        <h2 className="font-evogria text-[36px] text-ivory text-center !mb-5">
          THE HOME OF <span className="text-primary text-inherit font-evogria">STRENGTH TRAINING</span>
        </h2>
        <p className="font-roboto-condensed text-base leading-6 text-white text-center tracking-[0.5px]">
          Take your at-home training to the next level and enhance your physical and mental health with structured strength-based
          workouts, taught by industry-leading instructors.
        </p>
      </div>
    </div>
  )
}
